import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.813 2.5A2.813 2.813 0 0 0 5 5.313v19.375A2.813 2.813 0 0 0 7.813 27.5h14.375A2.813 2.813 0 0 0 25 24.688V12.5h-7.187A2.813 2.813 0 0 1 15 9.688V2.5zm9.062.55v6.638c0 .516.42.937.938.937h6.638zm-1.562 11.325c.517 0 .937.42.937.938v8.124a.937.937 0 1 1-1.875 0v-8.125c0-.518.42-.937.938-.937m4.374 3.125c.518 0 .938.42.938.938v5a.937.937 0 1 1-1.875 0v-5c0-.519.42-.938.938-.938m-8.75 1.875c.518 0 .938.42.938.938v3.125a.937.937 0 1 1-1.875 0v-3.125c0-.519.42-.938.938-.938" }, null, -1)
  ]))]))
}
export default { render: render }